// 聚餐状态统一配置：0 球员请客，1 球队买单，2 已取消，3 对方豪请，4 球员AA。
export const DINNER_STATUS = {
    PLAYER_HOST: 0,
    TEAM_PAY: 1,
    CANCELLED: 2,
    OPPONENT_HOST: 3,
    PLAYER_AA: 4,
};

export const DINNER_PAY_OPTIONS = [
    { label: '球队买单', value: DINNER_STATUS.TEAM_PAY },
    { label: '球员请客', value: DINNER_STATUS.PLAYER_HOST },
    { label: '球员AA', value: DINNER_STATUS.PLAYER_AA },
    { label: '对方豪请', value: DINNER_STATUS.OPPONENT_HOST },
];

export const DINNER_HAPPY_PAY_OPTIONS = [
    { label: '球员请客', value: DINNER_STATUS.PLAYER_HOST },
    { label: '球队买单', value: DINNER_STATUS.TEAM_PAY },
    { label: '球员AA', value: DINNER_STATUS.PLAYER_AA },
];

export const getDinnerStatusMeta = (status) => {
    const value = Number(status);
    if (value === DINNER_STATUS.TEAM_PAY) return { label: '球队买单', className: 'team', alert: '本次聚餐由【球队官方】买单，大家尽情享用！' };
    if (value === DINNER_STATUS.OPPONENT_HOST) return { label: '对方豪请', className: 'opponent', alert: '本次聚餐由【对方豪爽】请客，尽显体育家精神！' };
    if (value === DINNER_STATUS.PLAYER_AA) return { label: '球员AA', className: 'aa', alert: '本次聚餐为【球员AA】，快乐均摊，轻松开吃！' };
    if (value === DINNER_STATUS.CANCELLED) return { label: '已取消', className: 'cancelled' };
    return { label: '球员请客', className: 'player', alert: '' };
};

export const isDinnerHostDisabled = (status) => {
    // 球队买单、对方豪请、球员AA 都不需要展示或新增请客人员。
    return [DINNER_STATUS.TEAM_PAY, DINNER_STATUS.OPPONENT_HOST, DINNER_STATUS.PLAYER_AA].includes(Number(status));
};
